import {observable} from "mobx";
import {formatarDataCustomHTML, formatNullableValue, situacaoFormatter, 
        formatarDataCustomHTMLDisable, formatarDisabledRow} from "../../../../utils/formatar";
import {sortCaret} from "../../../comum/components/Icones";
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default class ImportacaoDetalhesStore {

    @observable documentosExpandido;
    @observable notasExpandido;
    @observable bookingsExpandido;

    @observable modalCarregarDoc;
    @observable modalAdicionarChaves;
    @observable modalAvisoMudarTipoDoc;

    @observable mostrarModalInativar;
    idInativar;
    protocoloInativar;
    @observable deuErrado;

    @observable salvandoEmail;
    @observable alertaEmail;
    @observable alertaProcesso;
    @observable email;

    @observable showModalDesistencia;
    @observable desistenciaMensagem;
    
    @observable showModalArquivos;

    @observable salvando;
    @observable enviandoParaAnalise;
    @observable listaMensagens;
    @observable atualizaDadosProcesso;

    constructor(service) {
        this.tipoDeProcessoSelecionado = {};
        
        this.documentosExpandido = true;
        this.notasExpandido = true;
        this.bookingsExpandido = true;

        this.modalCarregarDoc = false;
        this.modalAdicionarChaves = false;
        this.mostrarModalInativar = false;
        this.modalAvisoMudarTipoDoc = false;

        this.salvandoEmail = false;
        this.alertaEmail = false;
        this.alertaProcesso = false;
        this.email = false;
        this.showModalDesistencia = false;
        this.desistenciaMensagem = "";

        this.deuErrado = false;

        this.salvando = false;
        this.enviandoParaAnalise = false;
        this.listaMensagens = false;

        this.service = service;
        this.atualizaDadosProcesso = true;

        //this.modalAdicionarChaves = true; // TODO remover
        //this.modalCarregarDoc = true; // TODO remover
    };

    cliqueExpandirDocumento = () => {
        this.documentosExpandido = !this.documentosExpandido;
    };

    cliqueExpandirNotas = () => {
        this.notasExpandido = !this.notasExpandido;
    };

    cliqueExpandirBookings = () => {
        this.bookingsExpandido = !this.bookingsExpandido;
    };

    onChangeTipoDeProcesso = async (value, protocoloId) => {
        try 
        {
            this.alertaProcesso = false;
            if (value!==null) {
                this.tipoDeProcessoSelecionado = value;
                let response = await this.service.alterarTipoProtocolo(value.value, protocoloId);                
                if (response!==null) {
                    if (!response.data.Sucesso) {
                        this.alertaProcesso = response.data.MensagemErro;
                    }
                }                
            }
        }
        catch(error)
        {
            this.alertaProcesso = "Não foi possível alterar";
            console.log(err)
        }
        

    };

    enviarPraAnalise = (protocoloId, controller, mudaTitulo) => {
        this.enviandoParaAnalise = true;
        this.service.enviarPraAnalise(protocoloId).then(response => {
            this.enviandoParaAnalise = false;
            if (response!==null) {
                if (!response.data.Sucesso) 
                {
                    this.listaMensagens = response.data.MensagemErro;
                } else 
                {
                    this.listaMensagens = "Enviado com sucesso";
                    controller.detalhesAtivo = false;                  
                    window.scrollTo(10, 10); // Bug da barra de rolagem com o cabeçalho do grid
                    mudaTitulo();
                }
            }
        }).catch(err => {
            this.enviandoParaAnalise = false;
            console.log(err)
        });
    };

    abrirDesistencia = () => {
        this.showModalDesistencia = true
    }

    fecharDesistencia = () => {
        this.showModalDesistencia = false
    }

    desistirVistoria = (docId) => {
        this.service.desistirVistoria(docId).then(response => {
            if (response.data.Sucesso) {
                this.desistenciaMensagem = "Desistência realizada com sucesso.";
                this.desistencia = true
            } else {
                this.desistenciaMensagem = "Erro na desistência.";
            }
        }).catch(err => console.log(err))
    }

    visualizarDocumento = (row) => {
        window.open(this.service.buscarDocumento(row.InfDocId));
    };

    inativarDocumento = (id, ProtocoloId, tipo) => {
        this.idInativar = id;
        this.protocoloInativar = ProtocoloId;
        this.mostrarModalInativar = tipo;
    };

    confirmaInativar = (callback) => {
        this.salvando = true;
        this.service.inativarDocumento(this.idInativar, this.protocoloInativar).then(response => {
            this.salvando = false;
            if (response!==null && response.data.Sucesso) {
                callback();
                this.mostrarModalInativar = false;
            } else 
            {
                if (response.data.MensagemErro)
                    this.deuErrado = response.data.MensagemErro
                else
                    this.deuErrado = response;
            }
        }).catch(err => {
            this.salvando = false;
            console.log(err)
        })
    };

    salvarEmail = (email, blId) => {
        this.salvandoEmail = true;
        this.service.salvarEmail(email, blId).then(response => {
            this.salvandoEmail = false;
            if (response!==null) {
                if (!response.data.Sucesso) {
                    this.alertaEmail = response.data.MensagemErro;
                } else {
                    this.alertaEmail = false
                }
            }
        }).catch(err => {
            this.alertaEmail = "Não foi possível alterar";
            this.salvandoEmail = false;
            console.log(err)
        })
    };

    colunasDocumentos = [
        {
            dataField: "DscArquivo",
            text: "Descrição",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDisabledRow,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "Documento",
            text: "Tipo",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDisabledRow,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "DataCadastro",
            text: "Inclusão",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTMLDisable,
            headerAlign: (column, colIndex) => 'left',
            align: () => 'left'
        },
        {
            dataField: "DatInativo",
            text: "Inativação",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTMLDisable,
            headerAlign: (column, colIndex) => 'left',
            align: () => 'left'
        }
    ];

    colunasNotas = [
        {
            dataField: "ChaveAcessoNf",
            text: "Chave",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "NumeroNota",
            text: "NF",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "TipoNota",
            text: "Tipo de Nota",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "DataCadastroNf",
            text: "Inclusão",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
            align: () => 'left'
        },
        {
            dataField: "DatInativo",
            text: "Inativação",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            headerAlign: (column, colIndex) => 'left',
            align: () => 'left'
        },
        {
            dataField: "DscTipoServico",
            text: "Retirada de Carga",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: (column, colIndex) => 'left',
        },
        {
            dataField: "PendenciasNf",
            text: "Pendências",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "StatusNf",
            text: "Situação",
            sort: true,
            formatter: situacaoFormatter
        }
    ];

    colunasBookings = [
        {
            dataField: "NumeroBk",
            text: "Nº Booking",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        },
        {
            dataField: "CodCntr",
            text: "Containers",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatNullableValue,
            headerAlign: (column, colIndex) => 'left'
        }
    ];
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/stores/ImportacaoDetalhesStore.js